











import { Component, Vue } from 'vue-property-decorator';

@Component({})

export default class ExpandTransition extends Vue {
    constructor() {
        super();
    }

    public enter(element: any) {
        const width = getComputedStyle(element).width;

        element.style.width = width;
        element.style.position = 'absolute';
        element.style.visibility = 'hidden';
        element.style.height = 'auto';

        const height = getComputedStyle(element).height;

        element.style.width = null;
        element.style.position = null;
        element.style.visibility = null;
        element.style.height = 0;

        requestAnimationFrame(() => {
            element.style.height = height;
        });
    }

    public afterEnter(element: any) {
        element.style.height = 'auto';
    }

    public leave(element: any) {
        element.style.height = getComputedStyle(element).height;

        requestAnimationFrame(() => {
            element.style.height = 0;
        });
    }
}
